export default "__VITE_ASSET__ef53d34c__"